'use client';

import Image from 'next/image';

export default function Loading() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        backgroundColor: 'black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <Image src="/logo.png" alt="Casa Cazé TV Logo" width={200} height={200} />
    </div>
  );
}
